import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Menu from '../menu';
import { Table, Pagination, Button, Icon, Modal, Select, Input } from '../../components';
import { axios, Globals, Colors } from '../../utils';
import CreateEditZone from './create_edit_size';
import ViewSize from './view_size';
import $ from 'jquery';
import AddIcon from '../../assets/icons/add.png';

class Sizes extends React.Component {
	state = {
		header: [
			'Nombre',
			'Acciones'
		],
		page: 1,
		last_page: 1,
		data: [],
		brand: null,
		view: false,
		list_status: [
			{ value: '', label: 'Todos' },
			{ value: 0, label: 'Suspendidos' },
			{ value: 1, label: 'Activos' }
		],
		form: {
			status: null,
			search: null,
			user_id: this.props.user.role == 4 ? this.props.user.enterprise_users.enterprise_id : this.props.user.id,
			role: this.props.user.role
		}
	}
	componentDidMount() {
		this.load()
		setTimeout(async () => {
			await $('[data-toggle="tooltip"]').tooltip('hide');
		}, 300)
	}
	componentDidUpdate() {
		setTimeout(async () => {
			await $('[data-toggle="tooltip"]').tooltip('hide');
		}, 300)
	}
	componentWillUnmount() {
		if (this.state.searchTimeout) clearTimeout(this.state.searchTimeout);
	}
	load = () => {
		Globals.setLoading();
		axios.post('web/admin/sizes?page=' + this.state.page, this.state.form)
			.then(async res => {
				console.log(res)
				if (res.data) {
					await this.setState({
						last_page: res.data.sizes.data.last_page ?? 1,
						data: res.data.sizes.data
					});
				}
			})
			.catch(err => {
				Globals.showError();
			})
			.then(() => {
				Globals.quitLoading();
			});
	}

	getStatus = (status) => {
		let respuesta = "";
		switch (status) {
			case 0:
				respuesta = {
					text: "Suspendido",
					color: Colors.orange
				}
				break;
			case 1:
				respuesta = {
					text: "Activo",
					color: Colors.green
				}
				break;
			default:
				break;
		}
		return respuesta;
	}

	close = async () => {
		await this.setState({
			create: false,
			view: false,
			edit: null,
			brand: null,
		});
		await this.load()
	}

	suspend = (item, i) => {
		Globals.confirm('¿Desea suspender la color: ' + item.name + '?', () => {
			Globals.setLoading("Guardando...");
			axios.post('admin/brands/suspend', { id: item.id })
				.then(res => {
					Globals.showSuccess(res.data.msg);
					this.load();
				})
				.catch(err => {
					Globals.showError();
				})
				.then(() => {
					Globals.quitLoading();
				});
		});
	}

	activate = (item, i) => {
		Globals.confirm('¿Desea activar la color: ' + item.name + '?', () => {
			Globals.setLoading("Guardando...");
			axios.post('admin/brands/active', { id: item.id })
				.then(res => {
					Globals.showSuccess(res.data.msg);
					this.load();
				})
				.catch(err => {
					Globals.showError(err.response.data.msg);
				})
				.then(() => {
					Globals.quitLoading();
				});
		});
	}

	delete = (item, i) => {
		Globals.confirm('¿Desea eliminar la talla: ' + item.name + '?', () => {
			Globals.setLoading("Guardando...");
			axios.post('web/admin/sizes/delete', { size_id: item.id })
				.then(res => {
					Globals.showSuccess('Talla eliminada con exito');
					this.load();
				})
				.catch(err => {
					Globals.showError(err.response.data.msg);
				})
				.then(() => {
					Globals.quitLoading();
				});
		});
	}
	change = e => {
		const { name, value, type } = e.target;
		const isText = !['select-one', 'select-multiple', 'checkbox', 'radio'].includes(type);
		this.setState(
			state => ({ form: { ...state.form, [name]: value } }),
			() => this.autoFilter(isText)
		);
	};

	autoFilter = (isText = false) => {
		if (this.state.searchTimeout) clearTimeout(this.state.searchTimeout);
		if (isText) {
			const t = setTimeout(() => {
				this.setState({ page: 1 }, () => this.load());
			}, 700);
			this.setState({ searchTimeout: t });
		} else {
			this.setState({ page: 1 }, () => this.load());
		}
	};
	render() {
		return (
			<Menu history={this.props.history}>
				<Modal
					title="Ver talla"
					onClose={this.close}
					visible={this.state.view}>
					<ViewSize brand={this.state.brand} />
				</Modal>
				<Modal
					title={this.state.edit ? 'Editar talla' : "Nueva talla"}
					onClose={this.close}
					visible={this.state.create}>
					<CreateEditZone
						user={this.props.user}
						edit={this.state.edit}
						onClose={this.close} />
				</Modal>
				<div id="home">
					<div className="row">
						<div className="col-md-6 col-lg-5">
							<Input
								color=" "
								name="search"
								label="Búsqueda"
								className="filter"
								onChange={this.change}
								value={this.state.form.search}
								placeholder="Buscar por Nombre"
							/>
						</div>
					</div>
					<Table
						data={this.state.data.length}
						title="Tallas"
						header={this.state.header}
						right={
							<Button
								title="Agregar talla"
								small="true"
								onClick={() => {
									this.setState({
										create: true
									});
								}}
							>
								<img src={AddIcon} alt="Agregar talla" />
							</Button>
						}>
						{this.state.data.map((i, index) => {
							return (
								<tr key={index}>
									<td>{i.name}</td>
									{/* <td>{ i.code }</td> */}
									{/* <td>{ i.owner.person.first_name } { i.owner.deleted_at ? '(Eliminado)' : '' }</td> */}
									{/* <td style={ {color: this.getStatus(i.status).color }}>
											{ this.getStatus(i.status).text }
										</td> */}
									<td style={{ maxWidth: 'none' }}>
										<Button
											title="Ver"
											small="true"
											color="primary"
											style={{ backgroundColor: '#5c068c' }}
											onClick={() => {
												this.setState({
													brand: i,
													view: true
												});
											}}
										>
											<Icon name="eye" />
										</Button>
										<Button
											title="Editar"
											color=" "
											small="true"
											style={{ backgroundColor: '#0f54e0' }}
											onClick={() =>
												this.setState({
													create: true,
													edit: {
														element: i,
														index: index,
													}
												})}
										>
											<Icon name="edit" />
										</Button>
										{/* { i.status === 0 && <Button color="warning" title="Activar" small="true" style={{backgroundColor: '#d39e00'}} onClick={ () => {
												this.activate(i,index);
											} }>
												<Icon name="check" />
											</Button> }
											{ i.status === 1 && (
												<Button color="warning" title="Suspender" small="true" style={{backgroundColor: '#d39e00'}} onClick={ () => this.suspend(i,index) }>
													<Icon name="close" />
												</Button>
											) } */}
										<Button color="red" title="Eliminar" small="true" onClick={() => this.delete(i, index)}>
											<Icon name="trash" />
										</Button>
									</td>
								</tr>
							)
						})}
					</Table>

					<Pagination
						pages={this.state.last_page}
						active={this.state.page}
						onChange={async page => {
							await this.setState({
								page: page
							});
							this.load();
						}} />
				</div>
			</Menu>
		)
	}
}

export default connect(state => {
	return {
		user: state.user
	}
})(Sizes);